import { Step } from "./types";

export const steps: Step[] = [
	{
		id: "category",
		type: "category",
		defaultNext: "protocol",
		title: "בחר קטגוריה",
	},
	{
		id: "protocol",
		type: "single",
		defaultNext: "diagnosis",
		title: "בחר פרוטוקול",
	},
	{
		id: "diagnosis",
		type: "single",
		defaultNext: "sensitivities",
		title: "בחר אבחנה",
	},
	{
		id: "sensitivities",
		type: "sensitivities",
		defaultNext: null,
		title: "רגישויות",
	},
];
